import { Component, Input, Output, EventEmitter, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomModalController } from '../../../shared/services/custom-modal-controller.service';
import { isDesktopViewport } from '../../../shared/utils/viewport.utils';

@Component({
  selector: 'app-header-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header-modal.component.html',
  styleUrls: ['./header-modal.component.scss']
})
export class HeaderModalComponent {
  private modalCtrl = inject(CustomModalController);

  @Input() title: string = '';
  @Input() showToggle: boolean = true;
  @Input() showClose: boolean = true;
  @Input() bgColor: string = 'var(--color-gray-100)';
  @Input() maxHeight: number = 0;
  
  @Output() toggleHeight = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  /** True when the modal is fully open (synced with CustomModalController state) */
  isFullyOpen = computed(() => this.modalCtrl.modalState() === 'open');
  isDesktop = isDesktopViewport;

  onToggleHeight(): void {
    if (isDesktopViewport()) {
      this.close.emit();
    } else {
      this.toggleHeight.emit();
    }
  }

  onClose(): void {
    this.close.emit();
  }
}
